import React from 'react';
import PropTypes from 'prop-types';
import DateFilter from '../common/dateFilter';
import Autocomplete from '../common/autocomplete';
import MultipleTagsInput from '../common/inputs/multipleTagsInput';

const validateDate = (filter, date) => {
  let dateValue;

  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return dateValue;
};

const Header = props => (
  <div className="header between">
    <div className="header_box_filter">
      <MultipleTagsInput
        categories={props.filter}
        filteredTags={props.filters.tags}
        language={props.language.filter}
        handleSubmit={props.handleSubmit}
      />
    </div>
  </div>
);

Header.propTypes = {
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/assignment_list/header.jsx